/**
 * Phase 3F: Governance Disclaimer Component
 * Visible disclaimer required for all Phase 3 features
 */

import React from 'react';
import { AlertTriangle, Info } from 'lucide-react';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { PHASE3_DISCLAIMER } from '@/lib/governance/types';

interface Phase3DisclaimerProps {
  variant?: 'banner' | 'inline' | 'compact';
  className?: string;
}

export function Phase3Disclaimer({ 
  variant = 'inline',
  className = '' 
}: Phase3DisclaimerProps) {
  if (variant === 'banner') {
    return (
      <div className={`bg-amber-50 dark:bg-amber-950/30 border-b border-amber-200 dark:border-amber-800 px-4 py-2 ${className}`}>
        <div className="flex items-center gap-2 text-sm text-amber-800 dark:text-amber-200">
          <AlertTriangle className="h-4 w-4 flex-shrink-0" />
          <span className="font-medium">Advisory Notice:</span>
          <span>{PHASE3_DISCLAIMER}</span>
        </div>
      </div>
    );
  }

  if (variant === 'compact') {
    return (
      <div className={`flex items-center gap-1.5 text-xs text-muted-foreground ${className}`}>
        <Info className="h-3 w-3 flex-shrink-0" />
        <span>{PHASE3_DISCLAIMER}</span>
      </div>
    );
  }

  // Default: inline alert
  return (
    <Alert className={`border-amber-200 bg-amber-50 dark:border-amber-800 dark:bg-amber-950/30 ${className}`}>
      <AlertTriangle className="h-4 w-4 text-amber-600 dark:text-amber-400" />
      <AlertDescription className="text-amber-800 dark:text-amber-200">
        <span className="font-medium">Advisory Notice: </span>
        {PHASE3_DISCLAIMER}
      </AlertDescription>
    </Alert>
  );
}
